// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_9d47cfa7","icon":"_58e08d52","pinterest":"_981744cf","facebook":"_4606f571"};